const MODULE_NAME = 'ChangeLogModule';

export const GET_CHANGELOG_ENTRIES = `${MODULE_NAME}/GET_CHANGELOG_ENTRIES`;
export const GET_CHANGELOG_HAS_MORE = `${MODULE_NAME}/GET_CHANGELOG_HAS_MORE`;
